import { createContext, useContext } from 'react';

/** Ações da estrutura da app que as páginas também usam: abrir «Gravar» e a pesquisa. */
export const ShellContext = createContext<{ openRecord: () => void; openSearch: () => void }>({
  openRecord: () => undefined,
  openSearch: () => undefined,
});

export const useShell = () => useContext(ShellContext);
